
import {
  getOAuth,
  getOAuthCertification,
} from '@/api/oauths';

const oauths = {
  state: {},
  mutations: {},
  actions: {
    fetchOAuth({ commit }, resdata) {
      return new Promise((resolve, reject) => {
       getOAuth(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    fetchOAuthCertification({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        getOAuthCertification(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  }
};
export default oauths;



// WEBPACK FOOTER //
// ./src/store/modules/oauths.js